module.exports = __webpack_public_path__ + "img/logo-preto-ultragaz.11013786.svg";